import { Box, styled } from "@mui/material";
export const TruffleModalContent = styled(Box)({});
//# sourceMappingURL=TruffleModalContent.js.map